import React from 'react';

import { Feature } from 'config/features';

import { useFeature } from 'hooks/useFeature';

interface FeatureProps {
    name: Feature;
    exclude?: boolean;
    fallback?: React.ReactNode;
}

const FeatureHelper: React.FC<React.PropsWithChildren<FeatureProps>> = ({
    children,
    name,
    exclude = false,
    fallback,
}) => {
    const featureActive = useFeature(name);
    if (featureActive !== exclude) {
        return <>{children}</>;
    }

    return fallback ? <>{fallback}</> : null;
};

export default FeatureHelper;
